import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { TestSpecification } from "./testTab.models";
import Dictionary from "../../../models/Dictionary";

const useStyles = makeStyles({
  bold: {
    fontWeight: "bold",
  },
});

type MessageType = "ALL" | "WARN" | "STD";

const PLURALS = {
  is: "are",
  specification: "specifications",
  was: "were",
};

function getPluralizer<D extends Dictionary<string>, E extends keyof D>(
  dictionary: D,
  test: boolean,
): (word: E) => E | D[E] {
  return (word) => (test ? dictionary[word] : word);
}

interface TestSpecificationMessageProps {
  additionalText?: { text: string; showFor: MessageType };
  specifications: TestSpecification[];
  warn?: boolean;
}
const TestSpecificationMessage: React.FC<TestSpecificationMessageProps> = ({
  additionalText,
  specifications,
  warn,
}) => {
  const classes = useStyles();
  const maybePlural = getPluralizer(PLURALS, specifications.length > 1);
  const specificationNames = (
    <span className={classes.bold}>{specifications.map((spec) => spec.testPlanVersionName).join(", ")}</span>
  );
  const { text: additional, showFor } = additionalText || {};

  const text = (
    <Typography paragraph variant="subtitle1">
      The following test {maybePlural("specification")} {maybePlural("was")} defined by the requester:{" "}
      {specificationNames}. {(showFor === "STD" || showFor === "ALL") && `${additional}`}
    </Typography>
  );
  const warnText = (
    <Typography paragraph variant="subtitle1" color="error">
      The following test {maybePlural("specification")} {maybePlural("was")} defined by the requester, but{" "}
      {maybePlural("is")} deprecated and cannot be used anymore: {specificationNames}.{" "}
      {(showFor === "WARN" || showFor === "ALL") && `${additional}`}
    </Typography>
  );

  if (specifications.length === 0) {
    return <></>;
  }

  return <>{warn ? warnText : text}</>;
};

export default TestSpecificationMessage;
